import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'ness-include-cds-agencies-filter',
  templateUrl: './include-cds-agencies-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IncludeCDSFilterComponent implements OnInit {
  @Input() public defaultIncludeCDSValue: boolean = false;  // Note: Default value (if no choice is already saved in session)
  @Input() public includeCDSFilterStorageKey: string = null;
  @Input() public suppressUI: boolean = false;
  @Input() public tooltipStyleClass: string = null;
  @Input() public labelText: string = "Include Collective Data Sharing (CDS) Agency(ies)";

  public includeCDSForm: FormGroup;

  private get _includeCDSFormValue(): boolean {
    return this.includeCDSForm.get('IncludeCDS').value;
  }

  private set _includeCDSFormValue(value: boolean) {
    this.includeCDSForm.get('IncludeCDS').setValue(value);
  }

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.includeCDSForm = this.fb.group({
      IncludeCDS: [this.defaultIncludeCDSValue]
    });
  }

  ngAfterViewInit(): void {
    this.setFormFromSession();
  }

  public applyFilters(): void {
    this.setSessionFromForm();
  }

  public resetToDefaultFilters(): void {
    this.setFormFromSession();
  }

  private setSessionFromForm(): void {
    if (!this.includeCDSFilterStorageKey) {
      return;
    }

    const includeCDS = this._includeCDSFormValue;
    sessionStorage.setItem(this.includeCDSFilterStorageKey, JSON.stringify(includeCDS));
  }

  private setFormFromSession(): void {
    if (!this.includeCDSFilterStorageKey) {
      // Not saving values (on purpose)
      return;
    }

    const includeCDSFilterJSON = sessionStorage.getItem(this.includeCDSFilterStorageKey);

    if (includeCDSFilterJSON) {
      const includeCDS = JSON.parse(includeCDSFilterJSON);

      if (includeCDS === true || includeCDS === false) {
        this._includeCDSFormValue = includeCDS;
      }
      else {
        // A non-valid value was saved
        sessionStorage.removeItem(this.includeCDSFilterStorageKey);
        this._includeCDSFormValue = this.defaultIncludeCDSValue;
      }
    }
    else {
      // No value was saved
      this._includeCDSFormValue = this.defaultIncludeCDSValue;
    }
  }
}
